import(/* webpackMode: "eager" */ "C:\\TKsBox\\Projects\\BuildCredits\\Web Application\\buildcredits\\src\\app\\not-found.tsx");
